import React from "react";
import { Link } from "react-router-dom";
import { BRAND, NEARBY_AREAS } from "@/lib/brand";
import { SERVICE_GROUPS, servicesByGroup, buildWaLink, serviceMessage, GENERAL_MESSAGE, trackWhatsApp } from "@/lib/services";
import { Phone, Mail, MessageCircle, MapPin, Instagram, Facebook, Youtube, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-4">
            <img src={BRAND.logo} alt="Velixa Health" className="h-14 w-auto bg-white rounded-xl p-2" />
            <p className="mt-5 text-white/85 max-w-sm">{BRAND.tagline} Nurse-led home healthcare in Bangalore — available 24 hours, all days.</p>
            <div className="mt-6 flex items-center gap-3">
              <a href="https://www.google.com/search?q=velixa+health" target="_blank" rel="noopener noreferrer" aria-label="Google Business Profile" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Globe className="w-4 h-4" /></a>
              <a href="https://instagram.com/velixahealth" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Instagram className="w-4 h-4" /></a>
              <a href="https://facebook.com/velixahealth" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Facebook className="w-4 h-4" /></a>
              <a href="https://youtube.com/@velixahealth" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Youtube className="w-4 h-4" /></a>
            </div>
          </div>

          {/* Services columns */}
          {SERVICE_GROUPS.map((g) => (
            <div key={g.key} className="lg:col-span-3">
              <h4 className="text-white text-[15px] font-bold mb-4">{g.title}</h4>
              <ul className="space-y-2.5">
                {servicesByGroup(g.key).map((s) => (
                  <li key={s.slug}>
                    <a
                      data-testid={`footer-link-${s.slug}`}
                      href={buildWaLink(serviceMessage(s.name))}
                      target="_blank" rel="noopener noreferrer"
                      onClick={() => trackWhatsApp(s.name)}
                      aria-label={`Chat on WhatsApp about ${s.name}`}
                      className="text-white/80 hover:text-white text-[14.5px]"
                    >
                      {s.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact + pages */}
          <div className="lg:col-span-2">
            <h4 className="text-white text-[15px] font-bold mb-4">Reach us</h4>
            <ul className="space-y-3 text-[14.5px]">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-care" /><a href={`tel:${BRAND.phoneTel}`} className="text-white/90 hover:text-white">{BRAND.phoneDisplay}</a></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-care" /><a href={`mailto:${BRAND.email}`} className="text-white/90 hover:text-white break-all">{BRAND.email}</a></li>
              <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-care" /><a href={buildWaLink(GENERAL_MESSAGE)} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsApp("Footer WhatsApp")} className="text-white/90 hover:text-white">WhatsApp us</a></li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-care mt-1" /><span className="text-white/80">Whitefield, Bengaluru · Serving all of Bangalore</span></li>
            </ul>

            <h4 className="text-white text-[15px] font-bold mt-6 mb-3">Pages</h4>
            <ul className="space-y-2 text-[14.5px]">
              <li><Link to="/" className="text-white/80 hover:text-white">Home</Link></li>
              <li><Link to="/services" className="text-white/80 hover:text-white">All services</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-white">About</Link></li>
              <li><Link to="/blog" className="text-white/80 hover:text-white">Health Blog</Link></li>
              <li><Link to="/privacy" className="text-white/80 hover:text-white">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[13px] text-white/60">
          <div>© {new Date().getFullYear()} Velixa Health · Nurse-led home healthcare · Bangalore</div>
          <div className="text-white/75">Open 24 hours, all days · UPI · Cash · Card · Bank transfer</div>
        </div>
      </div>
    </footer>
  );
}
